import { URLS } from '../../constants';
import apiClient from '../client';

interface SaveTranscriptionPayload {
  sessionId: string;
  runSessionId: string;
  sessionDate: string;
  startTime: string;
  endTime: string;
  transcriptionText: string;
  transcriptionName: string;
}

interface GetTranscriptionResponse {
  data: {
    transcriptionText: string;
    transcriptionName?: string;
  };
}

const transcriptionApi = {
  saveTranscription: (payload: SaveTranscriptionPayload) =>
    apiClient.post(URLS.saveTranscription, {
      data: payload,
    }),

  getTranscriptionByRunSessionId: (runSessionId: string) =>
    apiClient.post(URLS.getTranscription, {
      data: {
        runSessionId,
      },
    }),
  globalTranscriptionSearch: (searchTerm: string, dateFilters: any) => {
    let dateRange = null;
    if (Object.keys(dateFilters).length) {
      dateRange = {
        startDate: dateFilters[0].filterValue,
        endDate: dateFilters[1].filterValue,
      };
    }
    return apiClient.post(URLS.globalTranscriptionSearch, {
      data: {
        searchTerm,
        ...dateRange,
      },
    });
  },

  deleteTranscriptionById: (payload: { id: number }) =>
    apiClient.post(URLS.deleteTranscription, {
      data: payload,
    }),

  getTranscriptionById: (payload: { id: number }) =>
    apiClient.post(URLS.getTranscriptionById, {
      data: payload,
    }),
};

export default transcriptionApi;
